<div class="container-fluid contenedorGalardonado">
    <div class="row rowGalardonado" style="flex-wrap: nowrap;">
        <div class="col imagen">
            <img src="assets/img/icon/lateralEdicion.png" height="100%" alt="lateral">
        </div>
        <div class="col textoEdicion">
            <div class="edicion">
                <h3>{{numeroEdicionTexto}} EDICIÓN</h3>
            </div>
            <div class="galardonados">
                GALARDONADOS
            </div>
            <div class="periodo">
                {{anoEdicion}}
            </div>
        </div>
        <div class="col imagen">
            <img src="assets/img/icon/lateralEdicion.png" height="100%" style="transform: scaleX(-1);" alt="lateral">
        </div>
    </div>
</div>